export const CHAIN_ID_LS_KEY = 'chainId'

// THERE ARE ALSO SOME KEYS STORED BASED ON THE ROOM ID and GAME ID
// `endGame-${gameId}`
